const aboutSection = $('#about-section');
const aboutImagesParent = aboutSection.find('.about-section-descriptor-image-placer');
const aboutImages = aboutImagesParent.find('.about-section-descriptor-image');
const aboutDescriptorsParent = aboutSection.find('.about-section-descriptors-steps');
const aboutDescriptors = aboutDescriptorsParent.find('.descriptor-card');
const aboutContent = aboutSection.find('.about-section-content');
const aboutCardsList = aboutSection.find('.about-section-card-list');
const aboutCards = aboutSection.find('.big-num-card');
const newLines = [];
aboutDescriptors.each(function (index) {
  newLines[index] = $('<div>', {
    class: 'descriptor-line-second',
    css: {
      width: '0px',
      height: '1px',
      position: 'absolute',
      top: '0',
      left: '0',
      'background-color': 'var(--downriver-100)',
    },
  });
  $(this).append(newLines[index]);
});
newLines[0].width('100%');
CustomEase.create('aboutEase', '0.60, 0.00, 0.40, 1.00');

const aboutTitleAnimation = () => {
  const aboutTitle = aboutSection.find('.no-wrap-text');
  const titleLetters = Splitting({
    target: aboutTitle.get(0),
    by: 'chars',
  });
  const titleTL = gsap.timeline({ paused: true });
  titleTL.add(
    gsap.fromTo(
      titleLetters[0].chars,
      {
        y: '40%',
        opacity: 0,
        filter: 'blur(10px)',
      },
      {
        y: 0,
        opacity: 1,
        filter: 'blur(0px)',
        duration: 0.3,
        stagger: {
          each: 0.05,
        },
      }
    ),
    0
  );
  titleTL.add(
    gsap.fromTo(
      aboutTitle,
      {
        y: '30%',
      },
      {
        y: 0,
      }
    ),
    0
  );
  return titleTL;
};

const aboutDescriptorStep = (fromIndex, toIndex, direction) => {
  const descriptorsBefore = aboutDescriptors.slice(0, toIndex);
  const prevtHeight = aboutDescriptors.eq(fromIndex).outerHeight();
  const descriptorsParent = aboutDescriptors.parent();
  const duration = 0.003789 * prevtHeight + 0.3056;
  const descriptorsHeight = descriptorsBefore
    .map(function () {
      return pxToVw($(this).outerHeight());
    })
    .get()
    .reduce((sum, h) => sum + h, 0);
  const stepsGap = pxToVw(Number(descriptorsParent.css('gap').replace('px', '')));
  const stepOffset = descriptorsHeight + stepsGap * toIndex;
  gsap.to(newLines[fromIndex], {
    width: '0%',
    duration: 0.633,
    ease: 'aboutEase',
  });
  gsap.to(newLines[toIndex], {
    width: '100%',
    duration: duration,
    ease: 'aboutEase',
  });
  gsap.to(aboutImagesParent, {
    top: `${stepOffset}vw`,
    duration: duration,
    ease: 'aboutEase',
  });
  currentImage = aboutImages.eq(direction == 1 ? toIndex : fromIndex);
  gsap.to(currentImage, {
    top: direction == 1 ? 0 : '100%',
    duration: duration,
    ease: 'aboutEase',
  });
};

const aboutInAnimation = () => {
  const aboutInTL = gsap.timeline({ paused: true });
  aboutInTL.add(addElementInAnimation(aboutImagesParent, '100%', 0.833, 0).play(), 0);
  aboutDescriptors.each(function (index) {
    aboutInTL.add(addElementInAnimation($(this), '100%', 0.833, 0).play(), 0.1 * index);
  });
  return aboutInTL;
};

const aboutTrigger = () => {
  if (isDesktop() || isTablet()) {
    const embla = aboutSection.find('.embla');
    const viewport = embla.find('.embla__viewport');
    const OPTIONS = { align: 'start', dragFree: true, loop: true };
    const plugins = [EmblaCarouselAutoScroll({ speed: 1, stopOnMouseEnter: true, stopOnInteraction: false })];
    const emblaApi = EmblaCarousel(viewport.get(0), OPTIONS, plugins);
  }

  const aboutTL = isDesktop() ? aboutInAnimation() : false;
  if(aboutTL){
    ScrollTrigger.create({
      trigger: aboutSection,
      start: 'top top+=75%',
      end: 'top top',
      once: true,
      onEnter: () => {
        aboutTL.play();
      },
    });
  }

  aboutDescriptors.each(function (index) {
    if (index != aboutDescriptors.length - 1) {
      ScrollTrigger.create({
        trigger: $(this),
        start: 'top center',
        end: 'top center',
        onEnter: () => {
          aboutDescriptorStep(index, index + 1, 1);
        },
        onLeaveBack: () => {
          aboutDescriptorStep(index + 1, index, -1);
        },
      });
    }
  });
};


/*
$(window).on('heroReady', function () {
aboutTrigger();
});
*/

/*
const aboutObserver = new IntersectionObserver((entries) => {
  if (!entries[0].isIntersecting) return;
  aboutTrigger();
  aboutObserver.disconnect();
}, {
  rootMargin: '0px 0px 30% 0px',
  threshold: 0
});

aboutObserver.observe(aboutSection.get(0));
*/

addSectionObserver(aboutSection, aboutTrigger);